









































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Component, Prop } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import Confirmation from '@/components/Confirmation.vue';
import { eventBus, actionsEvent } from '@/setup';
import HandleErrors from '@/config/handleErrors';
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { LoadingService } from '@/services/loadingService';
import { Console } from 'console';
import { fetchRegistrar } from '../fetchRegistrar';

@Component({
  components: {
    MantenedorGrid,
    DatePicker,
    Confirmation,
  },
})
export default class SimsSolicitudes extends ComponenteBase {
  @Prop({ required: true }) solicitudesSelected: any;
  solicitudesIds: Array<number>;

  funcionalidad: Funcionalidades = Funcionalidades.TablaSimsRegistrarBajaSim;

  formFields: FormFieldDefMap = {
    estado: {
      label: 'Estado',
      value: '',
      id: '',
    },
    motivo: {
      label: 'Motivo',
      value: '',
      id: '',
    },
    dateStart: {
      label: 'Fecha Envío Desde',
      value: moment()
        .subtract(1, 'month')
        .startOf('day'),
      id: '',
    },
    dateEnd: {
      label: 'Fecha Envío Hasta',
      value: moment().endOf('day'),
      id: '',
    },
  };

  clienteDefecto = JSON.parse(localStorage.getItem('user')).clienteDefecto;
  usuarioId = JSON.parse(localStorage.getItem('user')).id;
  texto_reporte: string = '';
  async exportarExcel() {
    let self = this;
    this.loadingService.showLoading();
    return fetchRegistrar(
      {
        user_id: this.usuarioId,
        solicitudes: this.solicitudesIds,
        clienteDefecto: this.clienteDefecto,
      },
      //'conectaMoviDispositivos/exportar_pdf'
      'conecta_registra_baja_sim/exportar_excel'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.texto_reporte = data.data.MENSAJE_RESPUESTA;
          this.showReporteGenerado = true;
          return;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al exportar excel', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  showReporteGenerado: boolean = false;
  exportar() {
    this.showReporteGenerado = true;
  }

  closeReporte() {
    this.showReporteGenerado = false;
  }

  cargarSims() {
    this.solicitudesIds = this.solicitudesSelected.map((solicitud: any) => {
      return Number(solicitud.sbajasimnumero);
    });
    this.filtroRequerimiento(true);
  }

  handleBuscarClick() {
    this.filtroRequerimiento(true);
  }

  filtroRequerimiento(loadWidget: boolean) {
    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  cant_regs_pag: number = 9;
  pagina: number = 1;
  gridEvent: any = null;

  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.gridApi.setDomLayout('autoHeight');
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    let self = this;
    this.serverSide = {
      getRows(event: any): void {
        event.request.paginationSize = self.gridOptions.cacheBlockSize;
        this.pagina = Math.ceil(
          event.request.startRow / this.cant_regs_pag + 1
        );

        fetchRegistrar(
          {
            pagina: event.request.startRow,
            solicitudes: self.solicitudesIds,
          },
          'conecta_registra_baja_sim/get_filtered_sims'
        )
          .then((data: any) => {
            if (data.data.CODIGO_RESPUESTA == '1') {
              self.loadingService.hideLoading();
              event.successCallback(
                data.data.data.LISTA,
                Number(data.data.cant_regs_pag.TOTAL_REGISTROS)
              );
            } else {
              self.loadingService.hideLoading();
              self.$snotify.error(data.data.MENSAJE_RESPUESTA, {
                timeout: 3000,
              });
            }
          })
          .catch((error: any) => {
            self.loadingService.hideLoading();
            self.$snotify.error('Ocurrió un error al cargar la las sim cards', {
              timeout: 3000,
            });
          });
      },
    };
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };

  accionCrear: PermisoAccion = {
    accionCodigo: 2,
    visible: false,
  };

  accionExportar: PermisoAccion = {
    accionCodigo: 6,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [
    this.accionConsultar,
    this.accionCrear,
    this.accionExportar,
  ];

  dialog: Boolean = false;
  search: string = '';
  localeText: any = config.agGridTextos;
  gridOptions: GridOptions;
  loadingService = new LoadingService();
  handleErrors: HandleErrors = new HandleErrors();
  AccionesPerfilesAsociados: number = 0;

  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  serverSide: any;

  // Interfaces
  editedItem: IFuncionalidad = {};
  funcionalidades: Array<IFuncionalidad> = [];

  dateFormatter(params: any) {
    return params && params.movifecha_recibe != ''
      ? moment(params.value).format('YYYY/MM/DD HH:mm:ss')
      : '';
  }

  constructor() {
    super();

    this.columnDefs = [
      {
        headerName: 'Telco',
        field: 'telconame',
        resizable: true,
        sortable: true,
        hide: false,
        minWidth: 150,
        width: 150,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Plan',
        field: 'telcoplanname',
        resizable: true,
        sortable: true,
        width: 220,
        minWidth: 220,
        lockPinned: true,
      },
      {
        headerName: 'SIM Serie',
        field: 'simserienumero',
        sortable: true,
        resizable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
        filter: false,
      },
      {
        headerName: 'Sim Estado',
        field: 'estado',
        width: 150,
        minWidth: 150,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Ubicación',
        field: 'tipoubicaname',
        width: 250,
        minWidth: 250,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Equipo Serie Host',
        field: 'serienumero',
        width: 250,
        minWidth: 250,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'IMEI',
        field: 'serieimei',
        width: 250,
        minWidth: 250,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Tipo Equipo',
        field: 'tipoeqname',
        width: 250,
        minWidth: 250,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Patente',
        field: 'patente_vehiculo',
        width: 250,
        minWidth: 250,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
    ];

    this.gridOptions = {
      pagination: true,
      paginationPageSize: this.cant_regs_pag, //Solución Paginación
      cacheBlockSize: this.cant_regs_pag, //Solución Paginación
      paginationAutoPageSize: false,
      columnDefs: this.columnDefs,
      rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      rowSelection: 'single',
      columnTypes: {
        fecha: {
          sortable: true,
          resizable: true,
          filter: false,
        },
      },

      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        event.api.sizeColumnsToFit();
      },
    };
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }

  mounted() {}
}
